import { render, staticRenderFns } from "./Teams.view.vue?vue&type=template&id=aa79cc52&scoped=true&"
import script from "./Teams.view.vue?vue&type=script&lang=js&"
export * from "./Teams.view.vue?vue&type=script&lang=js&"
import style0 from "./Teams.view.vue?vue&type=style&index=0&id=aa79cc52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa79cc52",
  null
  
)

export default component.exports